<style lang="less">
.account-info-show-vue {
  display: flex;
  flex-direction: column;

  .h-panel-body {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px 24px;
  }

  .account-image {
    .h-avatar {
      width: 100px;
      margin: 0 auto;
    }
  }

  .account-name {
    text-align: center;
    font-size: 20px;
    line-height: 28px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);
    margin: 16px 0 6px;
  }

  .account-role {
    text-align: center;
    font-size: 13px;
    color: #8a8f99;
    margin: 0;
  }

  .account-desc {
    text-align: center;
    max-width: 240px;
    margin: 12px auto 0;
    color: #666;
    word-break: break-word;
  }
}
</style>
<template>
  <div class="h-panel account-info-show-vue">
    <div class="h-panel-body">
      <p class="account-image">
        <Avatar :src="account.avatar" :width="100"></Avatar>
      </p>
      <p class="account-name">{{ account.username || account.name }}</p>
      <p v-if="roleLabel" class="account-role">{{ roleLabel }}</p>
      <p v-if="account.desc" class="account-desc">{{ account.desc }}</p>
    </div>
  </div>
</template>
<script>
const ROLE_LABELS = {
  1: '系统管理员',
  2: '普通员工',
  3: 'Leader'
};

export default {
  props: {
    modelValue: Object
  },
  computed: {
    account: {
      get() {
        return this.modelValue || {};
      },
      set(value) {
        this.$emit('update:modelValue', value);
      }
    },
    roleLabel() {
      const roleId = Number(this.account.role_id || this.account.roleId || 0);
      return ROLE_LABELS[roleId] || '';
    }
  }
};
</script>
